module.exports = __webpack_public_path__ + "img/icon-kxpl.0b19c8fe.png";